module.exports = __webpack_public_path__ + "img/mind_skeleton_30.337370f0.png";